<template>
  <div v-if="!isResult" class="form-pc">
    <div class="header-banner" v-if="data.bannerImage || data.bannerImage">
      <img :src="data.bannerPath ? data.bannerPath : data.bannerImage" />
    </div>
    <div class="header-title" v-if="data.titleName">{{ data.titleName }}</div>
    <div class="header-subtitle" v-if="data.subTitleName">{{ data.subTitleName }}</div>
    <a-form ref="formRef" layout="vertical" :model="formData">
      <div v-for="(item, index) in data.filedList" :key="index">
        <div v-if="item.fieldType === '11'" style="margin-bottom: 24px">{{ item.fieldName }}</div>
        <div v-else>
          <a-form-item
            :label="item.fieldName"
            :name="item.fieldName"
            :rules="[
              {
                required: item.requiredFlag === '1',
                validator: (rule, value, callback) => validateUpload(rule, value, callback, item),
                trigger: trigger(item)
              }
            ]"
            v-show="item.isShow"
          >
            <!-- 1：单行文本 ， 2：多行文本 -->
            <Input
              v-if="['1', '2'].includes(item.fieldType)"
              :data="item"
              v-model:value="item.fieldValue"
              :disabled="(item.systemType === '7' && routeData.templateType === '1') || disabled"
              @blur="inputBlur(item)"
            ></Input>
            <!-- 3：单选 -->
            <Radio
              v-if="['3'].includes(item.fieldType)"
              :data="item"
              :disabled="disabled"
              @change="e => selectChange(e, item)"
            />
            <!-- 4：下拉单选 -->
            <Select
              v-if="['4'].includes(item.fieldType) && !item.systemType"
              :data="item"
              :disabled="disabled"
              @change="e => selectChange(e, item)"
            />
            <CountryStateSelect
              v-if="['4'].includes(item.fieldType) && item.systemType"
              :data="item"
              :disabled="disabled"
              :countryValue="countryValue"
              v-model:value="item.fieldValue"
              @change="countryChange"
            />
            <!-- 5：多选 -->
            <Checkbox
              v-if="['5'].includes(item.fieldType)"
              :data="item"
              :disabled="disabled"
              @change="e => selectChange(e, item)"
            />
            <!-- 6：日期选择 -->
            <DatePicker
              v-if="['6'].includes(item.fieldType)"
              :data="item"
              :disabled="disabled"
              dropdownClassName="pickerClass"
              @change="e => selectChange(e, item)"
            />
            <!-- 7：评分 -->
            <Rate
              v-if="['7'].includes(item.fieldType)"
              @change="e => selectChange(e, item)"
              :value="item.fieldValue"
              :update="true"
              :disabled="disabled"
            />
            <!-- 8：矩阵评分 -->
            <MatrixScore
              v-if="['8'].includes(item.fieldType)"
              :data="item"
              :update="true"
              :disabled="disabled"
              @updataMatrixScore="e => selectChange(e, item)"
            />
            <!-- 9：图片上传  10：附件上传 -->
            <!-- <Upload v-if="['9', '10'].includes(item.fieldType)" :data="item" /> -->
            <!-- 12：排序 -->
            <Sort
              v-if="['12'].includes(item.fieldType)"
              :data="item"
              :disabled="disabled"
              @change="e => selectChange(e, item)"
            />
          </a-form-item>
        </div>
      </div>
      <div class="disclaimer-class" v-if="data.disclaimer">{{ data.disclaimer }}</div>
      <a-form-item
        name="agreementChecked"
        :rules="[
          {
            required: true,
            validator: (rule, value, callback) => validateAgreement(rule, value, callback),
            trigger: 'change'
          }
        ]"
      >
        <div class="agreement-class">
          <a-checkbox v-model:checked="agreementChecked" @change="agreementChange"></a-checkbox>
          {{ data.agreementContent }}
          <span class="agreement-link" @click="agreementLink">{{ data.agreementUrl }}</span>
        </div>
      </a-form-item>
    </a-form>
    <div class="footer-class">
      <a-button
        v-if="!disabled"
        class="submit-button"
        type="primary"
        @click="submit"
        :loading="loading"
        >{{ data.submitButtonLanguage }}</a-button
      >
    </div>
  </div>
  <Result v-else :resultData="initData" />
  <PolicyModal
    v-if="policyModalVisible"
    @policyModalClose="policyModalClose"
    :title="data.agreementUrl"
  />
</template>
<script setup lang="ts">
import { i18nt } from '@/i18n'
import { ref, onMounted, watch } from 'vue'
import { message } from 'ant-design-vue'
import Input from './Input.vue'
import Radio from './Radio.vue'
import Select from './Select.vue'
import CountryStateSelect from './CountryStateSelect.vue'
import Checkbox from './Checkbox.vue'
import DatePicker from './DatePicker.vue'
import Rate from './Rate.vue'
import MatrixScore from './MatrixScore.vue'
import Result from './Result.vue'
import PolicyModal from './PolicyModal.vue'
import Sort from './Sort.vue'
// import Upload from './Upload.vue'
import { FormSubmit, EventSubmit } from '@/services/marketing-management/form-management'
import cloneDeep from 'lodash/cloneDeep'

const props = defineProps({
  initData: {
    type: Object,
    required: true,
    default: () => ({})
  },
  routeData: {
    type: Object,
    required: true,
    default: () => ({})
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  },
  isPreview: {
    required: true,
    type: Boolean,
    default: false
  }
})
const data = ref({})
const agreementChecked = ref(false)
const policyModalVisible = ref(false)
const formData = ref({})
const formRef = ref(null)
const logicConfigList = ref([])
const isResult = ref(false)
const countryValue = ref<string | undefined>(undefined)
const loading = ref(false)
const startTime = ref(0)

// 输入后清空校验
const inputBlur = (item: any) => {
  formRef.value.validateFields(item.fieldName)
}

const trigger = (item: any) => {
  switch (item.fieldType) {
    case '1':
    case '2':
    case '8':
    case '9':
    case '10':
      return 'blur'
    case '3':
    case '4':
    case '5':
    case '6':
    case '7':
    case '12':
      return ['change', 'blur']
  }
}
// 矩阵打分必填校验判断
const matrixScoreValidate = (item: any) => {
  if (item.fieldValue && item.fieldValue.length > 0) {
    const result = item.fieldValue.some(item => {
      return item.column.some(i => i.score === 0)
    })
    return !result
  }
  return false
}
// 必填校验
const validateAgreement = (rule, value, callback) => {
  if (!agreementChecked.value) {
    return Promise.reject(i18nt('ep_admin_tips_select'))
  }
  return Promise.resolve()
}
const validateUpload = (rule, value, callback, item) => {
  if (
    item.isShow &&
    ['3', '4', '5'].includes(item.fieldType) &&
    !item.systemType &&
    item.fieldValue &&
    item.fieldValue.length > 0
  ) {
    const result = item.fieldValue.some(item => item.othersFlag && !item.otherContent)
    if (result) return Promise.reject(i18nt('ep_admin_tips_input'))
  }
  if (item.requiredFlag === '1' && item.isShow && item.systemType === '7') {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    if (regex.test(item.fieldValue)) {
      return Promise.resolve()
    } else {
      return Promise.reject(i18nt('ep_admin_form_emailTips'))
    }
  }
  if (item.requiredFlag === '1' && item.isShow && ['1', '2'].includes(item.systemType)) {
    return item.fieldValue ? Promise.resolve() : Promise.reject(i18nt('ep_admin_tips_select'))
  }
  if (item.requiredFlag === '1' && item.isShow) {
    switch (item.fieldType) {
      case '1':
      case '2':
        return item.fieldValue ? Promise.resolve() : Promise.reject(i18nt('ep_admin_tips_input'))
      case '3':
      case '4':
      case '5':
      case '12':
        return item.fieldValue?.length > 0
          ? Promise.resolve()
          : Promise.reject(i18nt('ep_admin_tips_select'))
      case '6':
      case '7':
        return item.fieldValue ? Promise.resolve() : Promise.reject(i18nt('ep_admin_tips_select'))
      case '8':
        return matrixScoreValidate(item)
          ? Promise.resolve()
          : Promise.reject(i18nt('ep_admin_tips_select'))
      // case '9':
      // case '10':
      //   return Promise.reject(i18nt('请上传'))
    }
  } else {
    return Promise.resolve()
  }
}

const agreementLink = () => {
  policyModalVisible.value = true
}

const policyModalClose = () => {
  policyModalVisible.value = false
}

const agreementChange = () => {
  formRef.value.validateFields('agreementChecked')
}

const selectChange = async (e: any, item: any) => {
  item.fieldValue = e
  if (item.isShow && ['3', '4', '5', '12'].includes(item.fieldType) && item.fieldValue.length > 0) {
    formRef.value.validateFields(item.fieldName)
  }
  if (item.fieldType === '8' && matrixScoreValidate(item)) {
    formRef.value.validateFields(item.fieldName)
  }
}

const countryChange = (val: any) => {
  countryValue.value = val
}

const containsList = (arr1, arr2) => {
  return arr2.some(item => arr1.includes(item))
}
// 生成唯一uid
const getRandomNumber = () => {
  let randomNumber = localStorage.getItem('formUid')
  if (!randomNumber) {
    randomNumber = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
    localStorage.setItem('formUid', randomNumber)
  }
  return randomNumber
}

const submit = async () => {
  await formRef.value.validate()
  if (props.isPreview) {
    isResult.value = true
    return
  }
  if (loading.value) return
  try {
    loading.value = true
    let filedList = cloneDeep(
      data.value.filedList.filter(item => item.isShow && item.fieldType !== '11')
    )
    filedList = filedList.map(item => {
      if (
        item.fieldValue &&
        ['3', '4', '5', '8', '12'].includes(item.fieldType) &&
        !item.systemType
      ) {
        item.fieldValue = JSON.stringify(item.fieldValue)
      }
      return item
    })
    const params = {
      ...props.routeData,
      deviceId: getRandomNumber(),
      submitFieldList: filedList
    }
    if (props.routeData.templateType === '1') {
      await EventSubmit(params)
      isResult.value = true
    } else {
      const endTimer = new Date().getTime()
      params.modifiedBy = getRandomNumber()
      params.surveyLogId = props.initData.surveyLogId
      params.answerDate = Math.floor((endTimer - startTime.value) / 1000)
      await FormSubmit(params)
      isResult.value = true
    }
  } catch (error) {
  } finally {
    loading.value = false
  }
}

watch(
  () => data.value.filedList,
  value => {
    data.value.filedList.forEach(item => {
      if (item.displayData.length > 0) {
        item.isShow = item.displayData.some(i => {
          const result = data.value.filedList.find(n => n.id === i.id)
          if (result.fieldValue && result.isShow) {
            const arr = result.fieldValue.map(l => l.optionId) || []
            return arr.length > 0 && containsList(i.value, arr)
          }
          return false
        })
      }
    })
  },
  { deep: true }
)

onMounted(async () => {
  data.value = props.initData
  logicConfigList.value = data.value.filedList
    .filter(item => item.logicConfigList)
    .flatMap(item => item.logicConfigList)
  data.value?.filedList?.forEach(item => {
    item.displayData = []
    item.isShow = true
    logicConfigList.value.forEach(i => {
      if (i.displayFieldIdList.includes(item.id)) {
        item.displayData.push({ id: i.fieldId, value: i.optionIdList })
        item.isShow = false
      }
    })
  })
  startTime.value = new Date().getTime()
})
</script>

<style lang="less" scoped>
.form-pc {
  text-align: left;
  width: 1280px;
  margin: 24px auto;
  padding: 24px 140px;
  background-color: #fff;
  font-family: Segoe UI, Microsoft YaHei, Arial, Helvetica, sans-serif;
  color: rgba(0, 0, 0, 0.7);
}
.header-banner {
  margin-bottom: 16px;
  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 2px;
  }
}
.header-title {
  font-size: 28px;
  line-height: 36px;
  font-weight: 600;
  margin-bottom: 8px;
}
.header-subtitle {
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 20px;
}
.disclaimer-class {
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 8px;
}
.agreement-link {
  color: rgb(33, 150, 243);
  cursor: pointer;
}
.submit-button {
  min-width: 148px;
  background-color: rgb(215, 0, 15);
  border: 1px solid rgb(215, 0, 15);
  border-radius: 2px;
  &:hover {
    border-color: #ec5153;
    background-color: #ec5153;
  }
  &:focus {
    background-color: rgb(215, 0, 15);
    border: 1px solid rgb(215, 0, 15);
  }
}
:deep(.pickerClass) {
  .ant-picker-cell-today {
    .ant-picker-cell-inner {
      color: #d7150e;
      &::before {
        position: absolute;
        bottom: 0;
        left: 0;
        display: inline-block;
        width: 100%;
        height: 26px;
        color: #d7150e;
        content: '.';
        font-family: sans-serif;
        font-size: 30px;
        text-align: center;
        border: none !important;
      }
    }
  }
  .ant-picker-cell-selected {
    .ant-picker-cell-inner {
      color: #fff !important;
      background: #d7150e;
    }
  }
  .ant-picker-today-btn {
    color: #d7150e;
  }
}
:deep(.ant-form-item-label) {
  padding: 0;
  line-height: 32px;
  label {
    color: rgba(0, 0, 0, 0.7);
    font-weight: 600;
  }
}
:deep(.ant-form-item-required) {
  &::before {
    font-weight: 400;
    position: absolute;
    right: -10px;
    margin-right: 0 !important;
  }
}
:deep(.ant-form-item, .ant-form-item-has-success) {
  color: rgba(0, 0, 0, 0.7);
  .ant-input-affix-wrapper:hover {
    border-color: #4d4d4d !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none !important;
    border-color: #4d4d4d !important;
  }
  .ant-input {
    border-color: #b3b3b3 !important;
    box-shadow: none !important;
    &:focus {
      border-color: #4d4d4d !important;
    }
    &:hover {
      border-color: #4d4d4d !important;
    }
  }
  .ant-picker:hover {
    border-color: #4d4d4d !important;
  }
  .ant-picker-focused {
    box-shadow: none !important;
    border-color: #4d4d4d !important;
  }
  .ant-checkbox-wrapper {
    color: rgba(0, 0, 0, 0.7);
    .ant-checkbox-inner {
      background-color: #fff;
      border-color: #b3b3b3 !important;
      &::after {
        border-color: #d7150e;
      }
    }
    &:hover {
      .ant-checkbox-inner {
        background-color: rgba(215, 21, 14, 0.08) !important;
        border-color: #d7150e !important;
      }
    }
  }
  .ant-checkbox-wrapper-checked {
    .ant-checkbox-inner {
      background-color: #fff;
      border-color: #b3b3b3 !important;
      &::after {
        border-color: #d7150e !important;
      }
    }
    .ant-checkbox-checked::after {
      border-color: #b3b3b3 !important;
    }
    &:hover {
      .ant-checkbox-checked::after {
        border-color: #d7150e !important;
      }
      .ant-checkbox-inner {
        background-color: rgba(215, 21, 14, 0.08) !important;
        border-color: #d7150e !important;
      }
    }
  }
  .ant-radio-wrapper {
    color: rgba(0, 0, 0, 0.7);
    .ant-radio-checked {
      border-color: #d9d9d9 !important;
      &::after {
        border: 1px solid #fa3239 !important;
      }
    }

    .ant-radio-inner {
      box-shadow: none !important;
      border-color: #d9d9d9 !important;
      &::after {
        background-color: #fa3239 !important;
      }
    }

    &:hover {
      .ant-radio-inner {
        border-color: #fa3239 !important;
        background-color: rgba(215, 21, 14, 0.08) !important;
      }
    }
  }
  .ant-select {
    .ant-select-selector {
      border: 1px solid #b3b3b3 !important;
      box-shadow: none !important;
    }
    &:hover {
      .ant-select-selector {
        border: 1px solid #4d4d4d !important;
      }
    }
  }
}
:deep(.ant-form-item-has-error) {
  color: rgba(0, 0, 0, 0.7);
  .ant-input-affix-wrapper:hover {
    border-color: #fa3239 !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none !important;
    border-color: #fa3239 !important;
  }
  .ant-input {
    box-shadow: none !important;
    border-color: #fa3239 !important;
    &:hover {
      border-color: #fa3239 !important;
    }
  }
  .ant-picker:hover {
    border-color: #fa3239 !important;
  }
  .ant-picker-focused {
    box-shadow: none !important;
    border-color: #fa3239 !important;
  }
  .ant-select {
    .ant-select-selector {
      border: 1px solid #fa3239 !important;
      box-shadow: none !important;
    }
    &:hover {
      .ant-select-selector {
        border: 1px solid #fa3239 !important;
      }
    }
  }
}
:deep(.sort-class) {
  .ant-checkbox-wrapper {
    .ant-checkbox-wrapper-checked {
      .ant-checkbox-inner::after {
        background-color: red;
        transform: rotate(0) scale(1) translate(0, 0) !important;
        top: 0;
        transition: none;
        border: none;
        color: #fff;
        content: attr(data-index);
      }
    }
  }
}
</style>
